export default __webpack_public_path__ + "static/media/marketplace-offers.3bfa6e2a.png";